import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    text: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    highlight: PropTypes.bool,
    showSelected: PropTypes.bool,
};

const defaultProps = {
    text: '',
    highlight: false,
    showSelected: false,
};

function ActionListItem(props){
    let className = "nav-list-item action";
    if (props.highlight) {
        className += " highlight";
    }
    if (props.showSelected) {
        className += " selected";
    }

    return (
        <div
            onClick={props.onClick}
            className={className}
        >
            {props.text}
        </div>
    );
}

ActionListItem.propTypes = propTypes;
ActionListItem.defaultProps = defaultProps;

export default ActionListItem;
